<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">

</head>
<body>
  <div class="flex flex--align-center bottom-row" style="justify-content: end !important;">
  </div>
  <form [formGroup]="ForecastData" (ngSubmit)="onSubmit()">
    <div class="content">
      <div class="forecast-settings table-container">
        <div style="display: flex;     justify-content: space-between;">
          <div class="panel__header">
            <span class="panel__header__title">
              {{ "Forecast-Settings" | translate | async }}
            </span>
          </div>

          <div style="margin-bottom: 5px;">
            <button mat-raised-button color="warn" type="submit" (click)="NavigateTo()">   {{ "Preset Forecast Wear Rates" | translate | async }}</button>
          </div>
        </div>
        <table class="table table--full-width table--striped" *ngIf="forecastDataVM != null">
          <thead>
            <tr>
              <th>{{"Forecast Selection" | translate | async}}</th>
              <th class="radio-label"><label for="usage"> {{ "Usage (Hrs)" | translate | async }}</label><input class="forecast-radio-btn"
                  type="radio" id="usage" formControlName="Forecast_Method" value="1" [checked]="hourChecked"
                  (change)="OnUsageRadioValChange(1)"></th>
              <th class="radio-label"><label for="distance"> {{ "Distance" | translate | async }}</label><input type="radio" id="distance"
                  class="forecast-radio-btn" formControlName="Forecast_Method" value="2" [checked]="!hourChecked"
                  (change)="OnUsageRadioValChange(2)"></th>
              <th>{{"Forecast Method" | translate | async}}</th>
              <th *ngIf="GetActionType==41"> {{ "Latest SMU/DOE" | translate | async }}</th>
              <th>
                        <mat-form-field class="margin-left-10">
                        <input  matInput  placeholder="{{'Distance Ratio' | translate | async}}"  type="text" formControlName="DistanceRatio"  (input)="limitOneDecimal($event)" ngDefaultControl>
                       </mat-form-field>
                <!-- <mat-form-field class="margin-left-10">
                  <input matInput placeholder="Distance Ratio" type="number" formControlName="DistanceRatio" 
                    ngDefaultControl>
                </mat-form-field> -->
              </th>
            </tr>
            <tr>
              <th>{{"Forecast" | translate | async}}</th>
              <th>{{"Hours" | translate | async}}</th>
              <th>{{userUOD | translate | async }}</th>
              <th>
                <input type="radio" class="forecast-radio-btn" style="margin-left:5px" id="Last3"
                  formControlName="PresetAvg" value="1" (change)="onforecastMethodCalution(1)"
                  [checked]="BoolRadioCheck"> <span class="w-125 margin">{{ "Average From Last 3 Inspections" | translate | async }}</span>
              </th>
              <th *ngIf="GetActionType==41">Date: {{InspectionForecastPreferenceModel.EventDate | date: 'dd MMM yyyy'}}
              </th>
              <th><mat-checkbox class="example-margin" [labelPosition]="after" formControlName="show100Worn">{{ "Show dates for 100% Worn" | translate | async }}</mat-checkbox></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><span class="w-125">{{"System Calculated Usage" | translate | async}}</span> <input type="radio"
                  class="forecast-radio-btn" style="margin-left:5px" id="calculatedUsageHrs"
                  formControlName="Daily_Usage_Calculation_Method" value="1" (change)="onRadioChange(1)"
                  [checked]="calculatedUsaghourChecked"></td>
              <td>{{forecastDataVM.ForecastEntryHours}} hrs</td>
              <td>{{ convertDistanceKmToMi(forecastDataVM.ForecastEntryDistance)}}</td>
              <td>

                <input type="radio" class="forecast-radio-btn" style="margin-left:5px" id="presetavg"
                  formControlName="PresetAvg" value="2" (change)="onforecastMethodCalution(2)"
                  [checked]="!BoolRadioCheck"><span class="w-125 margin">{{ "Preset Averages" | translate | async }}</span>
                
                  <span style="margin-left: 5px;">
                  
                  <label for="usage"> {{ "Safety Factor" | translate | async }}</label> <input type="text"
                    class="input-box" formControlName="SafteyFactor" style="width:70px">
                  </span>

                   <span style="margin-left: 5px;">
                  
                  <label for="usage"> {{ "MidPoint % " | translate | async }}</label> <input type="text"
                    class="input-box" formControlName="MidpointPercentage" style="width:70px">
                  </span>
              </td>
              <td *ngIf="GetActionType==41">{{ "SMU:" | translate | async }} {{InspectionForecastPreferenceModel.Smu}}</td>

              <td><mat-checkbox class="example-margin" [labelPosition]="after" formControlName="show120Worn">{{ "Show dates for 120% Worn" | translate | async }}</mat-checkbox></td>
            </tr>
            <tr>
              <td>
                <span class="w-125">{{" Manually Entered Usage" | translate | async}}</span> <input type="radio"
                  class="forecast-radio-btn" style="margin-left:5px" id="ManuallyEnteredUsage"
                  formControlName="Daily_Usage_Calculation_Method" value="2" (change)="onRadioChange(2)"
                  [checked]="!calculatedUsaghourChecked">
              </td>
              <td><input type="number"class="input-box"formControlName="Daily_Usage_Hours"(keyup)="onRadioChange(1)" min="0"max="24"  (input)="validateHours($event)"/>

        <div *ngIf="form?.get('Daily_Usage_Hours')?.hasError('max') && form?.get('Daily_Usage_Hours')?.touched" class="text-danger">Daily Usage Hours cannot be greater than 24</div>
              </td>
              <td><input type="text" class="input-box" formControlName="Daily_Usage_Distance"
                  (keyup)="onRadioChange(2)"></td>
              <td>
                <mat-radio-group aria-label="Select an option" formControlName="WeatherType"
                  [disabled]="BoolRadioCheck">
                  <mat-radio-button [value]="1"> {{"Winter" | translate | async}}</mat-radio-button>
                  <mat-radio-button [value]="2"> {{"Summer" | translate | async}}</mat-radio-button>
                  <mat-radio-button [value]="3"> {{"Shoulder" | translate | async}}</mat-radio-button>
                  <mat-radio-button [value]="4"> {{"Other" | translate | async}}</mat-radio-button>
                </mat-radio-group>
                <span *ngIf="ModelMachineLevel" class="font">{{"Machine Level" | translate | async}}</span>
                <span *ngIf="!ModelMachineLevel" class="font">{{"Model Level" | translate | async}}</span>
              </td>
              <td *ngIf="GetActionType==41">{{"DOE:" | translate | async}}{{InspectionForecastPreferenceModel.TotalDistance}}</td>
              <td><mat-checkbox class="example-margin" [labelPosition]="after" formControlName="showLastFourth">
                  {{"Show Last 4th Historical Inspection" | translate | async}}</mat-checkbox></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="forecast-settings table-container">
        <div class="panel__header">
          <span class="panel__header__title">
            {{ "Forecast Future Service" | translate | async }}
          </span>
        </div>
        <table class="table table--full-width table--striped" *ngIf="forecastDataVM != null">
          <thead>
            <tr style="text-align:center">
              <th>{{"Last Inspection" | translate | async}}</th>
              <th colspan="2" *ngIf="GetActionType==41"> {{ "Latest SMU" | translate | async }}</th>
              <th colspan="2">{{"Next PM Service" | translate | async}}</th>
              <th colspan="2">{{"2nd PM Service" | translate | async}}</th>
              <th colspan="2">{{"Floating Date" | translate | async}}</th>
              <th colspan="2">{{"Floating Date 2" | translate | async}}</th>
            </tr>
            <tr>
              <th></th>
              <th *ngIf="GetActionType==41"></th>
              <th>{{"Difference" | translate | async}}</th>
              <th></th>
              <th>{{"Difference" | translate | async}}</th>
              <th></th>
              <th>{{"Difference" | translate | async}}</th>
              <th></th>
              <th>{{"Difference" | translate | async}}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr style="text-align:center">

              <td>{{forecastDataVM.LastInpectionDate}}</td>
              <td *ngIf="GetActionType==41">{{InspectionForecastPreferenceModel.EventDate | date: 'dd MMM yyyy'}}</td>
              <td>{{dayDiff}} {{'Days' | translate | async}}</td>

              <td class="date-input">
                <!-- <mat-form-field>
                <input matInput [matDatepicker]="picker1" placeholder="{{'Choose a date' | translate | async}}"   formControlName="PM_1_Date" (dateChange)="onNextPmDateChange(1)"
                                min="{{_minDateNextPm | date:'yyyy-MM-dd'}}"  >
                
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field> -->
                <input [matDatepicker]="picker1" placeholder="{{'Choose a date' | translate | async}}"
                  formControlName="PM_1_Date" (dateChange)="onNextPmDateChange(1)"
                  min="{{_minDateNextPm | date:'yyyy-MM-dd'}}" />

                <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>

                <mat-form-field class="date-width">
                  <mat-select placeholder="PM Type" ngDefaultControl [(ngModel)]="forecastDataVM.PmNextServiceType"
                    formControlName="PmNextServiceType">
                    <mat-option [value]="0">
                         {{ "None" | translate | async }}
                    </mat-option>
                    <mat-option [value]="customer.TypeId" *ngFor="let customer of PmServiceTypes">
                      {{customer.TypeName}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
              <td>{{dayDiff1}} Days</td>
              <td class="date-input">
                <input [matDatepicker]="picker2" placeholder="{{'Choose a date' | translate | async}}" formControlName="PM_2_Date"
                  (dateChange)="onNextPmDateChange(2)" min="{{_minDateSecoundPm | date:'yyyy-MM-dd'}}" />
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
                <mat-form-field class="date-width">
                  <mat-select placeholder="Second PM Type" ngDefaultControl
                    [(ngModel)]="forecastDataVM.PmSecondServiceType" formControlName="PmSecondServiceType">
                    <mat-option [value]="0">
                     {{ "None" | translate | async }}
                    </mat-option>
                    <mat-option [value]="customer.TypeId" *ngFor="let customer of PmServiceTypes">
                      {{customer.TypeName}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
              <td>
                {{dayDiff2}}{{'Days' | translate | async}}
              </td>
              <td class="date-input">
                <input [matDatepicker]="picker3" placeholder="{{'Choose a date' | translate | async}}" formControlName="Floating_Date"
                  (dateChange)="onNextPmDateChange(3)" min="{{_minDateFlaotingDate1 | date:'yyyy-MM-dd'}}">
                <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                <mat-datepicker #picker3></mat-datepicker>
                <mat-form-field class="date-width">
                  <mat-select placeholder="Floating Date 1 Type" ngDefaultControl
                    [(ngModel)]="forecastDataVM.FloatingDate1ServiceType" formControlName="FloatingDate1ServiceType">
                    <mat-option [value]="0">
                      {{ "None" | translate | async }}
                    </mat-option>
                    <mat-option [value]="customer.TypeId" *ngFor="let customer of PmServiceTypes">
                      {{customer.TypeName}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
              <td>
                {{dayDiff3}} {{'Days' | translate | async}}
              </td>
              <td class="date-input">
                <input [matDatepicker]="picker4" placeholder="{{'Choose a date' | translate | async}}" formControlName="Floating_Date2"
                  (dateChange)="onNextPmDateChange(4)" min="{{_minDateFlaotingDate2 | date:'yyyy-MM-dd'}}" />
                <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                <mat-datepicker #picker4></mat-datepicker>
                <mat-form-field class="date-width">
                  <mat-select placeholder="Floating Date 2 PM Type" ngDefaultControl
                    [(ngModel)]="forecastDataVM.FloatingDate2ServiceType" formControlName="FloatingDate2ServiceType">
                    <mat-option [value]="0">
                      {{ "None" | translate | async }}
                    </mat-option>
                    <mat-option [value]="customer.TypeId" *ngFor="let customer of PmServiceTypes">
                      {{customer.TypeName}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
            </tr>
            <tr style="text-align:center">
              <td>{{ "SMU:" | translate | async }} {{forecastDataVM.LastinspectionSMU | number: '1.0-0'}}</td>
              <td *ngIf="GetActionType==41">SMU {{InspectionForecastPreferenceModel.Smu | number: '1.0-0'}}</td>
              <td>
                {{diffBetweenLastandPreviousInpectionUsgHours1 | number:'1.0-0'}} {{ "Hrs" | translate | async }}
              </td>
              <td>{{ "SMU:" | translate | async }} {{NextPMSMU | number: '1.0-0'}} </td>
              <td>
                {{diffBetweenLastandPreviousInpectionUsgHours2 | number:'1.0-0'}} {{ "Hrs" | translate | async }} 
              </td>
              <td>{{ "SMU:" | translate | async }} {{SecondPMSMU | number: '1.0-0'}}</td>
              <td>
                {{diffBetweenLastandPreviousInpectionUsgHours3 | number:'1.0-0'}} {{ "Hrs" | translate | async }}
              </td>
              <td> {{ "SMU:" | translate | async }} {{FloatingSMU | number: '1.0-0'}}</td>
              <td> {{ "SMU:" | translate | async }} {{diffBetweenLastandPreviousInpectionUsgHours4 | number:'1.0-0'}} {{ "Hrs" | translate | async }}</td>
              <td> {{ "SMU:" | translate | async }} {{FloatingSMU2 | number: '1.0-0'}}</td>
              <td> </td>
            </tr>
            <tr style="text-align:center">
              <td>{{ "DOE:" | translate | async }} {{ convertDistanceKmToMi(forecastDataVM.LastInspectionDistance) | number : '1.0-0'}}</td>
              <td *ngIf="GetActionType==41">{{ "DOE:" | translate | async }} {{
                convertDistanceKmToMi(InspectionForecastPreferenceModel.TotalDistance) | number : '1.0-0'}}</td>
              <td>{{ convertDistanceKmToMi(diffBetweenLastandPreviousInpectionDistance1) | number : '1.0-0'}}
                {{userUOD}}</td>
              <td>{{ "DOE:" | translate | async }} {{ convertDistanceKmToMi(NextPmDistance) | number : '1.0-0'}} </td>
              <td>{{ convertDistanceKmToMi(diffBetweenLastandPreviousInpectionDistance2) | number : '1.0-0'}}
                {{userUOD}}</td>
              <td>{{ "DOE:" | translate | async }} {{ convertDistanceKmToMi(SecondDistance) | number : '1.0-0'}}</td>
              <td>{{ convertDistanceKmToMi(diffBetweenLastandPreviousInpectionDistance3) | number : '1.0-0' }}
                {{userUOD}}</td>
              <td>{{ "DOE:" | translate | async }} {{ convertDistanceKmToMi(FloatingDistance) | number : '1.0-0'}} </td>
              <td>{{ convertDistanceKmToMi(diffBetweenLastandPreviousInpectionDistance4) | number : '1.0-0'}}
                {{userUOD}}</td>
              <td>{{ "DOE:" | translate | async }} {{ convertDistanceKmToMi(FloatingDistance2) | number : '1.0-0'}} </td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <div class="flex flex--align-center bottom-row" style="justify-content: end !important;">
          <div class="marginright10">
            <button mat-raised-button class="button" (click)="ResetFields()" type="button">{{ "Reset" | translate | async }}</button>
          </div>
          <div style="margin-bottom: 5px;">
            <button mat-raised-button color="warn" type="submit">{{ "Save/Refresh" | translate | async }}</button>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="content" *ngFor="let systemId of systemIds">
    <app-forecast-undercariage-detail [systemId]="systemId" [inspectionId]="inspectionId"
      [EvalautionRange]="EvalautionRange" [refreshComponents]="refreshComponents"></app-forecast-undercariage-detail>
  </div>
</body>
</html>